/* eslint-disable */
function getFormattedDate(isoDateTime){ // eslint-disable-line no-use-before-define
  if (!isoDateTime) {
    return "";
  }
  var dateTime = new Date(isoDateTime);
  var day = dateTime.getDate();
  if (day < 10) {
    day = "0" + day;
  }
  var month = dateTime.getMonth() + 1;
  if (month < 10) {
    month = "0" + month;
  }
  var fullYear = dateTime.getFullYear();
  var year = fullYear.toString().slice(2);
  return day + "/" + month + "/" + year
}

function getFormattedDateTime(isoDateTime){ // eslint-disable-line no-use-before-define
  if (!isoDateTime) {
    return "";
  }
  var dateTime = new Date(isoDateTime);
  var date = getFormattedDate(isoDateTime);
  var hour = dateTime.getHours();
  var minutes = dateTime.getMinutes();
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  var seconds = dateTime.getSeconds()
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  var ampm = "am";
  if( hour > 12 ) {
    hour -= 12;
    ampm = "pm";
  }
  return hour + ":" + minutes + ":" + seconds + " " + ampm + " " + date;
}

export {getFormattedDate, getFormattedDateTime}
/* eslint-enable */

